import { render, staticRenderFns } from "./MonthGrid.vue?vue&type=template&id=504ef410"
import script from "./MonthGrid.vue?vue&type=script&lang=js"
export * from "./MonthGrid.vue?vue&type=script&lang=js"
import style0 from "./MonthGrid.vue?vue&type=style&index=0&id=504ef410&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports